import { useState } from 'react';

type SetValue<T> = (newValue: T) => void;
type RemoveValue = () => void;

/**
 * Hook to use LocalStorage similarly to how the useState hook is used.
 */
export function useLocalStorage<T>(key: string, initialValue: T): [T, SetValue<T>, RemoveValue] {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (err) {
      console.error(err);
      return initialValue;
    }
  });

  const setValue: SetValue<T> = (value) => {
    try {
      setStoredValue(value);
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.error(err);
    }
  };

  const removeValue = () => {
    window.localStorage.removeItem(key);
  };

  return [storedValue, setValue, removeValue];
}



// WEBPACK FOOTER //
// ./src/hooks/useLocalStorage.ts